'use strict';
//Utilities
var React = require('react');
var ClassNames = require('classnames');
var Spinner = require('./Spinner.jsx');
var ApplicationConstants = require('../../constants/ApplicationConstants.js');


var RadioButtonList = React.createClass({
    propTypes: {
        id: React.PropTypes.string.isRequired,
        handleChange: React.PropTypes.func.isRequired,
        useHeadingStyle: React.PropTypes.bool,
        label: React.PropTypes.string,
        data: React.PropTypes.array,
        value: React.PropTypes.string,
        model: React.PropTypes.string,
        isValid: React.PropTypes.bool,
        isHidden: React.PropTypes.bool,
        errorHeading: React.PropTypes.string,
        errorMessage: React.PropTypes.string,
        customClass: React.PropTypes.string
    },
    getDefaultProps: function () {
        return {
            isValid: true,
            isHidden: false
        };
    },
    handleOnChange: function (event) {
        if (this.props.handleChange) {
            event.target['model'] = this.props.model;
            this.props.handleChange(event);
        }
    },
    render: function () {
        if (this.props.isHidden) {
            return null;
        }
        var radioButtonListRow = function (item) {
            var id = this.props.id + '-' + item.id;
            var trKey = 'tr-' + id;
            var inputKey = 'input-' + id;
            var nameKey = 'name-' + id;
            var code = null;
            if (item.code) {
                var codeKey = 'code-' + id;
                code = <td className="table-ref table-vote value" key={codeKey}>{item.code}</td>;
            }

            var itemID = item.id.toString();
            var description = (item.description)
                ? <div className="radio-button-list-description">{item.description}</div>
                : null;

            return <tr key={trKey}>
                <td className="form-select table-vote">
                    <label htmlFor={inputKey} tabIndex="0" className={ClassNames('radio-button-list-options', { 'btn-cfs': this.props.value === itemID, 'radio-button-list-has-description': description }) }>
                        <i className="icon icon-check"></i>
                        <input id={inputKey} tabIndex="-1" name={this.props.id} type="radio" className="btn-option btn btn-default btn-lg" disabled={item.disabled} value={item.id} onChange={this.handleOnChange} checked={this.props.value === itemID} />
                    </label>
                    <div key={nameKey}>{item.name}</div>
                    {description}
                </td>
                {code}
            </tr>;
        }.bind(this);

        var radioButtonRows = '';
        if (this.props.data && this.props.data instanceof Array && this.props.data.length >= 1) {
            radioButtonRows = this.props.data.map(function (item, index) {
                return radioButtonListRow(item, index);
            });
        }

        var label = (this.props.label) ? <label>{this.props.label}</label> : null;

        if (this.props.useHeadingStyle) {
            label = <h2>{this.props.label}</h2>;
        }

        var hideSpinner = this.props.data && this.props.data.length > 0;
        var spinner = <Spinner hide={hideSpinner} size={ApplicationConstants.SpinnerSizes.Three} />;
        var styles = ['table', 'table-single', 'radio-button-list'];
        if(this.props.customClass) {
            styles.push(this.props.customClass);
        }
        return (
            <div className="form-section">
                <div className="form-label-section">
                    {label}
                </div>
                {spinner}
                <table className={ClassNames(styles)} id={`radioButtonTable_${this.props.id}`}>
                    <tbody>
                        {radioButtonRows}
                    </tbody>
                </table>
            </div>
        );
    }
});

module.exports = RadioButtonList;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/Common/RadioButtonList.jsx